import { AlertCircle, RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "./alert";
import { Pill } from "./pill";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  variant?: "card" | "inline";
}

export function ErrorState({ title = "오류 발생", message, onRetry, variant = "card" }: ErrorStateProps) {
  if (variant === "inline") {
    return (
      <div className="flex items-center gap-2 text-sm text-destructive">
        <AlertCircle className="w-4 h-4" />
        <span>{message}</span>
        {onRetry && (
          <Pill variant="secondary" size="sm" onClick={onRetry}>
            <RefreshCw className="w-3 h-3 mr-1" />재시도
          </Pill>
        )}
      </div>
    );
  }
  return (
    <Alert variant="destructive" className="my-4">
      <AlertCircle className="w-4 h-4" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="flex items-center gap-2">
        <span>{message}</span>
        {onRetry && (
          <Pill variant="secondary" size="sm" onClick={onRetry}>
            <RefreshCw className="w-3 h-3 mr-1" />재시도
          </Pill>
        )}
      </AlertDescription>
    </Alert>
  );
}
